import React, { useMemo, useContext, useState } from 'react';
import RegisterContext from '../../RegisterContext';
import { Row, Form, Button } from "react-bootstrap";
import useForm from 'hooks/useForm';
import { fieldsForm, schema } from './fields'

export default function NotIsraeliStep({ labels, push }) {

  const { user, setUser, goToStepsProcess } = useContext(RegisterContext)
  const [displayConvertPassport, setDisplayConvertPassport] = useState(false);

  if (user) {
    push('already_registered')
  }
  const {
    formik,
    renderElementsForm,
    renderElement
  } = useForm({
    fieldsForm,
    schema,
    onSubmit: handleSubmit
  })

  const formElements = useMemo(() => renderElementsForm(), [fieldsForm]);

  function convertPassport() {
    setDisplayConvertPassport(true)
  }
  function handleSubmit(values) {
    goToStepsProcess()
  }
  function renderOptions() {
    let options = [{
      1: "1"
    }, {
      2: "2"
    }
    ]
    return <React.Fragment>
      {options.map(o =>
        <option>{Object.values(o)}</option>
      )}
    </React.Fragment>
  }
  return (
    <div>
      <Form onSubmit={formik.handleSubmit}>
        {renderElement(formElements[0], labels, renderOptions())}
        <div className="convert-wrapper">
          {renderElement(formElements[1], labels)}
          <Button className="btn medium" onClick={convertPassport}>המרה למספר ת.ז. מומר </Button>
        </div >
        {
          displayConvertPassport && <Row>
            <p tabIndex={0}>1111111111</p>
          </Row>
        }
        {renderElement(formElements[2], labels, renderOptions())}
        <Button className="btn_submit" aria-label={labels.continue} variant="primary" type="submit" >
          {labels.continue}
        </Button>
      </Form>
    </div>
  )
}
